export const getDateDaysAgo = (days) => {
  let dateDaysAgo = ''

  const oneMillisecond = 1000
  const oneSecond = (oneMillisecond * 1)
  const oneMinute = (oneSecond * 60)
  const oneHour = (oneMinute * 60)
  const oneDay = (oneHour * 24)
  const daysAgo = (oneDay * days)

  const date = new Date(new Date() - daysAgo)

  const year = date.getFullYear()
  let month = `${(date.getMonth() + 1)}`
  const day = date.getDate()

  if (month.length === 1) {
    month = `0${month}`
  }

  dateDaysAgo = `${year}-${month}-${day}`

  return dateDaysAgo
}



// WEBPACK FOOTER //
// ./src/common/contentful/lib/getDateDaysAgo.js